<template>
  <b-modal
      id="create-share-person"
      title="Share Person"
      header-bg-variant="success"
      header-text-variant="light"
      size="lg"
      :visible="showModal"
      centered
      @hidden="reset"
    >
      <p>
        Share all associated components of this person record (e.g., screenings, notes, advocates, and external ids) with a group.
      </p>
      <!-- If a group is not selected: present options -->
      <b-list-group flush>
        <b-list-group-item
          v-for="group in userGroups"
          :key="group.id"
        >
          <span>{{ _.get(group, 'groupName', '') }}</span>
          <b-button
            v-if="isAllowedToSharePerson"
            type="button"
            variant="outline-primary"
            size="sm"
            class="float-right"
            @click="shareHandler(group)"
          >
            <span class="button-text">Share</span>
          </b-button>
        </b-list-group-item>
      </b-list-group>
      <!--
      <b-form v-show="(!selectedGroup) || userGroups.length > 1">
        <b-form-select
          :options="userGroups"
          v-model="selectedGroup"
          v-on:change="selectGroupHandler($event)"
          placeholder="Type to Search"
        >
          <template slot="first">
            <option :value="null" disabled>-- Please select a group --</option>
          </template>
        </b-form-select>
      </b-form>
      -->
      <b-alert
        dismissible
        fade
        :show="!_.isEmpty(sharePersonResponse)"
        :variant="sharePersonResponse.error ? 'danger' : 'success'"
      >
        <span v-html="apiResponseMessage(sharePersonResponse)"></span>
      </b-alert>

      <div slot="modal-footer"></div>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import userPermission from '@/mixins/userPermission'

export default {
  name: 'create-share-person-modal',
  mixins: [userPermission],
  props: {
    personId: Number,
    personFid: String,
    personOrganizationOwner: Number,
    person: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  updated: function () {
    /*
    if (!this.userSelection) {
      if (this.$store.getters.userCurrentContext.group.id) {
        this.selectedGroup = this.$store.getters.userCurrentContext.group
      } else {
        let data = this.userShareAllowedGroups(this.personOrganizationOwner)
        let item = data[0]
        this.selectedGroup = item.id
        this.userSelection = true
      }
    }
    */
  },
  components: {
  },
  data: function () {
    return {
      selectedGroup: false,
      showModal: false
    }
  },
  computed: {
    // Create a computed property that looks at userContextOrganizationGroups and filters out Groups as a result of orgs that are not the records owningOrg
    // Do you have org admin rights for the owningOrg for this record
    ...mapGetters({
      // userShareAllowedGroups: 'userShareAllowedGroups',
      groupsByOrg: 'getGroupsByOrg',
      sharePersonResponse: 'sharePersonResponse',
      sharePersonRecords: 'sharePersonRecords'
    }),
    userGroups () {
      if (!this.groupsByOrg) {
        return []
      }

      const currentSharedGroups = this.sharePersonRecords.map((g) => g.sgroup.id)
      return this.groupsByOrg.filter((g) => !currentSharedGroups.includes(g.id))
    }
  },
  watch: {
    sharePersonResponse: function (newValue) {
      if (this.showModal && newValue.success) {
        _.delay(this.reset, 1000)
      }
    }
  },
  methods: {
    toggleShareModal: function () {
      this.showModal = !this.showModal
    },
    shareHandler: function (group) {
      this.selectedGroup = group
      const personId = this.personId
      const groupId = this.selectedGroup.id
      const personPath = this.personFid

      if (!personId || !groupId) {
        this.$store.commit('SET_SHARE_PERSON_RESPONSE', { success: false, error: { code: 'INVALID_API_CALL', message: 'Incorrect parameters' } })
      }

      if (personId && groupId) {
        this.$store.dispatch('sharePerson', {
          personId,
          groupId
        }).then(res => {
          let self = this
          if (this.sharePersonResponse.success) {
            setTimeout(function () { self.$bvModal.hide('create-share-person') }, 2000)
            setTimeout(function () { self.$emit('createAndSharePerson', personPath) }, 3000)
          }
        })
      }
    },
    apiResponseMessage: function (response) {
      let message = response.message

      if (!response.success && response.error) {
        message = this.$utils.errorToHtml(response.error)
      }

      if (response.success) {
        message = 'Success!'
      }

      message = '<p>' + message + '</p>'
      return message
    },
    reset: function () {
      this.selectedGroup = false
      this.$store.commit('RESET_SHARE_RESPONSE', { name: 'sharePersonResponse' })
    }
  },
  beforeDestroy () {
    this.reset()
  },
  mounted: function () {
    this.userGroup = this.selectedGroup
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Share/CreateSharePersonModal.vue